
export default function TypingIndicator() {
  return (
    <div className="flex items-center gap-2 px-4 py-2">
      <div className="flex items-center gap-1.5 bg-gray-100 rounded-2xl px-4 py-3">
        <span className="w-2 h-2 bg-gray-400 rounded-full typing-dot" />
        <span className="w-2 h-2 bg-gray-400 rounded-full typing-dot" />
        <span className="w-2 h-2 bg-gray-400 rounded-full typing-dot" />
      </div>
    </div>
  );
}
